export function createPageUrl(pageName: string): string {
    return '/' + pageName.toLowerCase().replace(/ /g, '-');
}
